import axios from "axios";

const CONFIGURED_BACKEND = process.env.REACT_APP_BACKEND_URL?.replace(/\/$/, "") || "";
const IS_LOCAL_DEV =
  typeof window !== "undefined" &&
  ["localhost", "127.0.0.1"].includes(window.location.hostname);
const BACKEND = IS_LOCAL_DEV ? CONFIGURED_BACKEND : "";

export const API = `${BACKEND}/api`;

// httpOnly cookies carry auth; we never store JWTs in localStorage.
export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

export function formatApiError(err) {
  const d = err?.response?.data?.detail;
  if (d == null) return err?.message || "Something went wrong";
  if (typeof d === "string") return d;
  if (Array.isArray(d))
    return d.map((e) => (e?.msg ? e.msg : JSON.stringify(e))).join("; ");
  if (typeof d === "object") {
    if (d.problem && d.resolution) return `${d.problem}. ${d.resolution}`;
    if (d.problem) return d.problem;
    if (d.msg) return d.msg;
  }
  return String(d);
}

/** Return { field, problem, resolution } if the backend returned a structured error, else null. */
export function structuredApiError(err) {
  const d = err?.response?.data?.detail;
  if (d && typeof d === "object" && !Array.isArray(d) && (d.problem || d.field)) {
    return { field: d.field || null, problem: d.problem || "", resolution: d.resolution || "" };
  }
  return null;
}
